export const Config = {
  main_url: 'https://attendance-slim.stlordsinternationalpublicschool.com',
  mainpy_url: 'https://attendance-python.stlordsinternationalpublicschool.com',
};
